import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "statistics-list" }
const _hoisted_2 = { class: "statistics-list__cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_StatisticsListFilter = _resolveComponent("StatisticsListFilter")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_HintComponent = _resolveComponent("HintComponent")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_header, { class: "statistics-list__header" }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("h3", null, "Statistics", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_el_container, { class: "statistics-list__filter" }, {
      default: _withCtx(() => [
        _createVNode(_component_StatisticsListFilter)
      ]),
      _: 1 /* STABLE */
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "statistics-list__table",
      data: _ctx.statisticsList,
      "row-class-name": _ctx.getRowClassName,
      border: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.STATISTICS_LIST_COLUMN_LIST, (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: column.prop
          }, { ref_for: true }, column), {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", {
                  class: _normalizeClass(column.cellClass?.(row))
                }, _toDisplayString(column.formatter ? column.formatter(row) : row[column.prop]), 3 /* TEXT, CLASS */),
                (column.hintKey && row.section)
                  ? (_openBlock(), _createBlock(_component_HintComponent, {
                      key: 0,
                      "show-title": false,
                      name: column.hintKey(row),
                      "hint-list": _ctx.STATISTICS_LIST_HINT_MAP
                    }, null, 8 /* PROPS */, ["name", "hint-list"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data", "row-class-name"])), [
      [_directive_loading, _ctx.isStatisticsListLoading]
    ])
  ]))
}